import { w } from 'windstitch';

export const CardsBox = w.div(
  'lg:my-[128px] gap-y-[64px] lg:gap-y-[128px] flex flex-col relative w-full xl:w-[1200px] px-4 x1:px-0',
);

export const Card = w.div(
  'relative w-full h-auto lg:h-[224px] md:gap-12 rounded-[24px] p-12 bg-[var(--lime-500)] text-[var(--lime-800)] flex  justify-center lg:sticky ',
);

export const CardTitle = w.h2(
  'font-roboto font-bold text-[20px] md:text-[32px] leading-[40px] tracking-[1px] text-center lg:text-left',
);

export const CardText = w.p(
  'font-open-sans font-semibold text-[14px] md:text-[20px] leading-[28px] tracking-[0px] mt-[24px] text-center lg:text-left',
);